import React from 'react';
import { CNAME, default as ValuePropsItem } from './ValuePropsItem';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../Intl';
import { LockShield, LuggageGlobe, Tea, Currency } from './Icons/Icons';
import EdapModuleView from '../EdapModuleView';
import { MODULE_VIEW_EVENT_OPTIONS } from './events';
import cnames from 'classnames';

import './ValueProps.less';

const ValueProps = ({ isTablet }) => (
  <section className="Content__section">
    <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
      <ul className={cnames(`${CNAME}__list`, 'row', 'app-wrapper', { 'app-wrapper--isTablet': isTablet })}>
        <FormattedMessage id={['value.proposition.safety.heading', 'value.proposition.safety.subheading']}>
          {(title, blurb) => (<ValuePropsItem icon={<LockShield />} {...{ title, blurb, isTablet }} />)}
        </FormattedMessage>
        <FormattedMessage id={['value.proposition.experience.heading', 'value.proposition.experience.subheading']}>
          {(title, blurb) => (<ValuePropsItem icon={<LuggageGlobe />} {...{ title, blurb, isTablet }} />)}
        </FormattedMessage>
        <FormattedMessage id={['value.proposition.selection.heading', 'value.proposition.selection.subheading']}>
          {(title, blurb) => (<ValuePropsItem icon={<Tea />} {...{ title, blurb, isTablet }} />)}
        </FormattedMessage>
        <FormattedMessage id={['value.proposition.value.heading', 'value.proposition.value.subheading']}>
          {(title, blurb) => (<ValuePropsItem icon={<Currency />} {...{ title, blurb, isTablet }} />)}
        </FormattedMessage>
      </ul>
    </EdapModuleView>
  </section>
);

ValueProps.propTypes = {
  isTablet: PropTypes.bool.isRequired
};

export default ValueProps;
